var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2"},[_c('h6',{staticClass:"\n      text-prim-grad-1\n      fw-bolder\n      text-left\n      pb-1\n      border-bottom border-line-grey\n    "},[_vm._v(" La tua agenda ")]),_c('b-row',[_c('Calendario')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }